{
  "actionWithDelay": "Wait {{seconds}}s, then {{action}}",
  "areYouSureYouWantToDisconnectTheseDevices": "Are you sure you want to disconnect these devices?",
  "changesFrom": "Changes from: ",
  "connectDevices": "Connect Devices",
  "newConnection": "New Connection",
  "connectedToTitle": "Connected To:",
  "connectionsWithConnectionCount": "{{connectionCount}} Connection(s)",
  "connectedToWithDeviceCount": "Connected to: {{deviceCount}}",
  "connectionsListTitle": "Device Connections",
  "createTitle": "New Device Connection",
  "deleteConnection": "Delete Connection",
  "deviceConnectionsListEmpty": "No inter-device connections have been created yet. Tap 'Connect Devices' to get started.",
  "disconnect": "Disconnect",
  "notificationsDisabled": "Notifications Disabled for Connection",
  "notificationsEnabled": "Notifications Enabled for Connection",
  "selectedConnectionTitle": "Device Connection",
  "sendANotificationWhen": "Send a notification when...",
  "sendNotificationsToUsers": "Notifications:",
  "source": "Source",
  "target": "Target",
  "targetDevice": "Target Device"
}
